export default __webpack_public_path__ + "static/media/anvilCover.fbcd1865.png";